import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import * as InputTypes from 'customer-data-filters-ui/filterQueryFormat/InputTypes';
import * as UnifiedEventPropertyTypes from 'customer-data-filters-ui/filterQueryFormat/UnifiedEventPropertyTypes';
import { useStrategy } from './useStrategy';
import { useContext } from 'react';
import getIn from 'transmute/getIn';
import FilterOperatorAssociationInput from 'customer-data-filters-ui/components/operator/FilterOperatorAssociationInput';
import FilterOperatorBoolInput from 'customer-data-filters-ui/components/operator/FilterOperatorBoolInput';
import FilterOperatorCountInput from '../components/operator/FilterOperatorCountInput';
import FilterOperatorCtaInput from 'customer-data-filters-ui/components/operator/FilterOperatorCtaInput';
import FilterOperatorDateInput from 'customer-data-filters-ui/components/operator/FilterOperatorDateInput';
import FilterOperatorDateInputMoment from 'customer-data-filters-ui/components/operator/FilterOperatorDateInputMoment';
import { FilterOperatorEndOfDateInputMomentWithTime, FilterOperatorStartOfDateInputMomentWithTime } from '../components/operator/FilterOperatorDateInputMomentWithTime';
import FilterOperatorDurationInput from 'customer-data-filters-ui/components/operator/FilterOperatorDurationInput';
import FilterOperatorEmailLinkInput from 'customer-data-filters-ui/components/operator/FilterOperatorEmailLinkInput';
import FilterOperatorHighValueInput from 'customer-data-filters-ui/components/operator/FilterOperatorHighValueInput';
import FilterOperatorPropertyInput from 'customer-data-filters-ui/components/operator/FilterOperatorPropertyInput';
import FilterOperatorRollingDateInput from 'customer-data-filters-ui/components/operator/FilterOperatorRollingDateInput';
import FilterOperatorRollingInequalityInput from 'customer-data-filters-ui/components/operator/FilterOperatorRollingInequalityInput';
import FilterOperatorRollingInequalityInputOperatorSelect from '../components/operator/FilterOperatorRollingInequalityInputOperatorSelect';
import FilterOperatorRollingPropertyUpdated from 'customer-data-filters-ui/components/operator/FilterOperatorRollingPropertyUpdated';
import FilterOperatorRollingWithUnitInput from 'customer-data-filters-ui/components/operator/FilterOperatorRollingWithUnitInput';
import FilterOperatorTeamInput from '../components/operator/FilterOperatorTeamInput';
import FilterOperatorTextInput from 'customer-data-filters-ui/components/operator/FilterOperatorTextInput';
import FilterOperatorUrlEqualityInput from '../components/operator/FilterOperatorUrlEqualityInput';
import FilterOperatorUrlEqualityInputResponsive from '../components/operator/FilterOperatorUrlEqualityInputResponsive';
import FilterOperatorValueInput from 'customer-data-filters-ui/components/operator/FilterOperatorValueInput';
import FilterOperatorEnumInput from 'customer-data-filters-ui/components/operator/FilterOperatorEnumInput';
import FilterOperatorEmailSubscriptionInput from 'customer-data-filters-ui/components/operator/FilterOperatorEmailSubscriptionInput';
import FilterOperatorNumberInput from 'customer-data-filters-ui/components/operator/FilterOperatorNumberInput';
import FilterOperatorPercentageInput from 'customer-data-filters-ui/components/operator/FilterOperatorPercentageInput';
import FilterOperatorMultiStringInput from 'customer-data-filters-ui/components/operator/FilterOperatorMultiStringInput';
import FilterOperatorCurrencyCodeInput from '../components/operator/FilterOperatorCurrencyCodeInput';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import FilterOperatorOwnerInput from 'customer-data-filters-ui/components/operator/FilterOperatorOwnerInput';
import FilterOperatorDateRangeInput from 'customer-data-filters-ui/components/operator/FilterOperatorDateRangeInput';
import FilterOperatorDateRangeInputMoment from 'customer-data-filters-ui/components/operator/FilterOperatorDateRangeInputMoment';
import FilterOperatorDateRangeInputMomentOperatorSelect from '../components/operator/FilterOperatorDateRangeInputMomentOperatorSelect';
import { hasAnniversaryFiltering, hasDateTimeHoursFiltering, hasFieldOverrideV2, hasTimeZoneInputEnabled } from '../permissions/gates';
import FilterOperatorRollingDatePointInput from '../components/operator/FilterOperatorRollingDatePointInput';
import { Map as ImmutableMap } from 'immutable';
import { UNIFIED_EVENT } from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import FilterOperatorDateStaticOrDynamicInput from '../components/operator/FilterOperatorDateStaticOrDynamicInput';
import AfterTimePointWithTime from '../filterQueryFormat/operator/AfterTimePointWithTime';
import FilterOperatorDateRangeInputMomentWithTime from '../components/operator/FilterOperatorDateRangeInputMomentWithTime';
import { shouldUseEnumComponentsForExternalOptionsField } from '../utils/externalOptionsConversionUtils';
import { isRelativeTimeProperty } from '../utils/isRelativeTimeProperty';
import FilterOperatorDateDurationInput from '../components/operator/FilterOperatorDateDurationInput';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import { TEAM as TeamExternalOptionType } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import FilterOperatorTimeZoneEnumInput from '../components/operator/FilterOperatorTimeZoneEnumInput';
import { PHONE_NUMBER } from '../constants/aditionalPropertyTypes';
export const getInputWrapper = (inputType, useOnePanel) => {
  switch (inputType) {
    case InputTypes.NoInputType:
      return null;
    case InputTypes.PropertyInputType:
      return FilterOperatorPropertyInput;
    case InputTypes.AssociationInputType:
      return FilterOperatorAssociationInput;
    case InputTypes.CtaInputType:
      return FilterOperatorCtaInput;
    case InputTypes.DateStaticOrDynamicInputType:
      return FilterOperatorDateStaticOrDynamicInput;
    case InputTypes.EmailLinkInputType:
      return FilterOperatorEmailLinkInput;
    case InputTypes.RangeInputType:
      return FilterOperatorHighValueInput;
    case InputTypes.RollingDateInputType:
      return FilterOperatorRollingDateInput;
    case InputTypes.RollingDatePointInputType:
      return FilterOperatorRollingDatePointInput;
    case InputTypes.RollingBoundedInequalityInputType:
      return FilterOperatorRollingInequalityInput;
    case InputTypes.RollingBoundedInequalityWithOrWithoutYearInputType:
      return hasAnniversaryFiltering() ? FilterOperatorRollingInequalityInputOperatorSelect : FilterOperatorRollingInequalityInput;
    case InputTypes.RollingInequalityInputType:
      return FilterOperatorRollingInequalityInput;
    case InputTypes.RollingWithUnitInputType:
      return FilterOperatorRollingWithUnitInput;
    case InputTypes.RollingPropertyUpdatedInputType:
      return FilterOperatorRollingPropertyUpdated;
    case InputTypes.UrlInputType:
      return useOnePanel ? FilterOperatorUrlEqualityInputResponsive : FilterOperatorUrlEqualityInput;
    default:
      return FilterOperatorValueInput;
  }
};
export const getInputComponent = (condition, filterFamily, fieldDefinitions, referencedObjectType, getIsUngated, getOperatorsForType, useHoursFiltering) => {
  var _field$options$size, _field$options;
  const field = condition.field;
  let fieldType = getIn([field === null || field === void 0 ? void 0 : field.name, 'inputType'], fieldDefinitions) || getIn([field === null || field === void 0 ? void 0 : field.type, 'inputType'], fieldDefinitions) || (field === null || field === void 0 ? void 0 : field.displayType) || (field === null || field === void 0 ? void 0 : field.type);
  const FieldDefinitionInputComponent = getIn([field === null || field === void 0 ? void 0 : field.name, 'InputComponent'], fieldDefinitions);
  if (FieldDefinitionInputComponent) {
    return FieldDefinitionInputComponent;
  }
  const shouldUseEnumInput = shouldUseEnumComponentsForExternalOptionsField(field, condition, filterFamily, getOperatorsForType, getIsUngated);

  // TEAM reference fields must use a FilterOperatorTeamInput for UX reasons
  if ((field === null || field === void 0 ? void 0 : field.referencedObjectType) === ReferenceObjectTypes.TEAM || (field === null || field === void 0 ? void 0 : field.externalOptionsReferenceType) === TeamExternalOptionType) {
    return FilterOperatorTeamInput;
  }
  if ((field === null || field === void 0 ? void 0 : field.name) === 'hs_timezone' && ((_field$options$size = field === null || field === void 0 || (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.size) !== null && _field$options$size !== void 0 ? _field$options$size : 0) > 0 && hasTimeZoneInputEnabled()) {
    return FilterOperatorTimeZoneEnumInput;
  }
  if (shouldUseEnumInput) {
    return FilterOperatorEnumInput;
  }
  if (fieldType === 'number' && (field === null || field === void 0 ? void 0 : field.numberDisplayHint) === 'duration') {
    return FilterOperatorDurationInput;
  }
  if (isRelativeTimeProperty(field)) {
    return FilterOperatorDateDurationInput;
  }
  if ((field === null || field === void 0 ? void 0 : field.type) === 'number' && (field === null || field === void 0 ? void 0 : field.numberDisplayHint) === 'percentage') {
    return FilterOperatorPercentageInput;
  }
  if (referencedObjectType === ReferenceObjectTypes.OWNER) {
    return FilterOperatorOwnerInput;
  }
  if (condition.constructor.inputType === InputTypes.RangeInputType && condition.constructor.displayType === DisplayTypes.MomentDate) {
    return hasAnniversaryFiltering() ? FilterOperatorDateRangeInputMomentOperatorSelect : FilterOperatorDateRangeInputMoment;
  }
  if (condition.constructor.inputType === InputTypes.RangeInputType && condition.constructor.displayType === DisplayTypes.MomentDateWithTime) {
    return FilterOperatorDateRangeInputMomentWithTime;
  }
  if (condition.constructor.inputType === InputTypes.RangeInputType && (fieldType === DisplayTypes.DateDisplayType || fieldType === DisplayTypes.DatetimeDisplayType)) {
    return FilterOperatorDateRangeInput;
  }

  // display properties of type "number" with referencedObjectType specified
  // as "enumeration" input
  if (getIsUngated('CRM:Filters:ReferencedEnumInput') && fieldType === PropertyTypes.NUMBER && referencedObjectType) {
    fieldType = PropertyTypes.ENUMERATION;
  }
  if ((fieldType === DisplayTypes.StringDisplayType || fieldType === PHONE_NUMBER) && condition.constructor.isIterableField('value')) {
    return FilterOperatorMultiStringInput;
  }
  if (fieldType === DisplayTypes.CountDisplayType && filterFamily === UNIFIED_EVENT) {
    return FilterOperatorCountInput;
  }
  switch (fieldType) {
    case DisplayTypes.BooleanDisplayType:
      return FilterOperatorBoolInput;
    case DisplayTypes.DateDisplayType:
      return condition.constructor.displayType === DisplayTypes.MomentDate ? FilterOperatorDateInputMoment : FilterOperatorDateInput;
    case DisplayTypes.DatetimeDisplayType:
      if (condition.constructor.displayType === DisplayTypes.MomentDateWithTime) {
        if (hasDateTimeHoursFiltering(getIsUngated) && useHoursFiltering) {
          return condition.constructor === AfterTimePointWithTime ? FilterOperatorEndOfDateInputMomentWithTime : FilterOperatorStartOfDateInputMomentWithTime;
        } else {
          return FilterOperatorDateInputMoment;
        }
      } else {
        return condition.constructor.displayType === DisplayTypes.MomentDate ? FilterOperatorDateInputMoment : FilterOperatorDateInput;
      }
    case DisplayTypes.EnumerationDisplayType:
    case ReferenceObjectTypes.SITE_CONTENT:
    case ReferenceObjectTypes.SURVEY_QUESTION:
    case UnifiedEventPropertyTypes.OBJECT_COORDINATES:
      return FilterOperatorEnumInput;
    case ReferenceObjectTypes.EMAIL_SUBSCRIPTION:
      return getIsUngated('subscriptions:groupSettings') ? FilterOperatorEmailSubscriptionInput : FilterOperatorEnumInput;
    case DisplayTypes.CommunicationSubscriptionDisplayType:
      return FilterOperatorEnumInput;
    case DisplayTypes.NumberDisplayType:
    case DisplayTypes.CountDisplayType:
      return FilterOperatorNumberInput;
    case DisplayTypes.PercentageDisplayType:
      return FilterOperatorPercentageInput;
    case InputTypes.MultiCurrencyCurrencyCode:
      return FilterOperatorCurrencyCodeInput;
    default:
      return FilterOperatorTextInput;
  }
};
export const useValueInputComponents = (filterFamily, condition) => {
  const {
    getFieldDefinitions,
    getReferencedObjectType,
    useHoursFiltering,
    getOperatorsForType
  } = useStrategy();
  const {
    getIsUngated,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const InputComponentWrapper = getInputWrapper(condition.constructor.inputType, useOnePanel);
  const InputComponent = getInputComponent(condition, filterFamily, hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : getFieldDefinitions(filterFamily), getReferencedObjectType(filterFamily, condition), getIsUngated, getOperatorsForType, useHoursFiltering);
  return {
    InputComponent,
    InputComponentWrapper
  };
};